import type { TShow } from '@schemas'

export const STATUS_LABELS: Record<TShow['status'], string> = {
  draft: 'Draft',
  accepting_entries: 'Accepting entries',
  judging: 'Judging',
  finalized: 'Finalized',
}

export const STATUS_TRANSITIONS: Record<TShow['status'], TShow['status'][]> = {
  draft: ['draft', 'accepting_entries'],
  accepting_entries: ['draft', 'accepting_entries', 'judging'],
  judging: ['accepting_entries', 'judging', 'finalized'],
  finalized: ['finalized', 'judging'],
}

export function buildStatusOptions({
  show,
  hasClasses,
  hasJudges,
  hasSecretaries,
  hasLeadSecretaries,
}: {
  show: TShow
  hasClasses: boolean
  hasJudges: boolean
  hasSecretaries: boolean
  hasLeadSecretaries: boolean
}) {
  void hasSecretaries
  const transitions = STATUS_TRANSITIONS[show.status] ?? [show.status]
  return transitions.map(value => {
    let disabled = false
    let reason: string | undefined

    if (value === 'accepting_entries' && !hasClasses) {
      disabled = true
      reason = 'Add at least one class before activating the show.'
    }

    if (value === 'finalized') {
      if (!hasClasses) {
        disabled = true
        reason = 'Add classes before finalizing the show.'
      } else if (!hasJudges || !hasLeadSecretaries) {
        disabled = true
        reason = 'Assign at least one judge and one lead secretary before finalizing.'
      }
    }

    if (value === 'judging' && (!hasClasses || !hasJudges || !hasLeadSecretaries)) {
      disabled = true
      reason =
        'Assign required staff (including a lead secretary) and confirm classes before starting judging.'
    }

    return {
      value,
      label: STATUS_LABELS[value],
      disabled,
      reason,
    }
  })
}
